// extracted by mini-css-extract-plugin
module.exports = {"svgCurve":"style_svgCurve__J_jO9"};